import { Controller } from "@hotwired/stimulus"

// A long report's sections, listed beside it on a wide screen so the
// merchant sees its shape and can jump. Built from the sections the page
// drew, so a section with nothing in it is never listed; a short report
// (under four sections) gets no list at all.
export default class extends Controller {
  static targets = ["section", "list", "nav"]

  connect() {
    if (!this.hasNavTarget || this.sectionTargets.length < 4) return

    this.links = this.sectionTargets.map((section) => {
      const item = document.createElement("li")
      const link = document.createElement("a")
      link.href = `#${section.id}`
      link.textContent = section.dataset.contentsLabel
      link.className = "block border-l-2 border-transparent py-1.5 pl-3 text-[15px] leading-snug text-muted hover:text-ink aria-[current=true]:border-ink aria-[current=true]:text-ink"
      item.append(link)
      this.listTarget.append(item)
      return link
    })
    this.navTarget.hidden = false

    this.observer = new IntersectionObserver((entries) => {
      entries.filter((entry) => entry.isIntersecting).forEach((entry) => this.mark(entry.target.id))
    }, { rootMargin: "0px 0px -75% 0px" })
    this.sectionTargets.forEach((section) => this.observer.observe(section))
  }

  disconnect() {
    this.observer?.disconnect()
    this.listTarget?.replaceChildren()
  }

  mark(id) {
    this.links.forEach((link) => link.setAttribute("aria-current", link.hash === `#${id}` ? "true" : "false"))
  }
}
